<template>
  <div
    class="flex-row-union"
    style="align-items: center;"
  >
    <i :class="icon" />
    <span>{{ file.name }}</span>
    <span style="color: var(--color-text-secondary);">{{ formatFileSize(file.size) }}</span>
    <slot name="actions" />
  </div>
</template>

<script setup lang="ts">
import {
  computed,
} from 'vue';

import {
  formatFileSize,
} from '@/constants/file-upload.ts';
import {
  getFileIcon,
} from '@/utils/icons.ts';

const props = defineProps<{
  file: File,
}>();

const icon = computed(() => getFileIcon(props.file.type));
</script>
